import {Theme, createStyles} from '@material-ui/core';

export const contactUsStyles = (theme: Theme) =>
	createStyles({
		root: {
			paddingBottom: theme.spacing(12),
			paddingTop: theme.spacing(12),
			[theme.breakpoints.between(theme.breakpoints.values.xs, theme.breakpoints.values.sm)]: {
				paddingBottom: theme.spacing(0),
			},
		},
	});
